// extracted by mini-css-extract-plugin
export default {"row":"Wk9v6E2L_FqNPemoK8Zq","cell":"P5xQaWV3JsYtZKfHJDcp"};